import React, { useMemo } from 'react';
import { Check, X } from 'lucide-react';

const PASSWORD_RULES = [
  { regex: /.{8,}/, label: 'Minimo 8 caratteri' },
  { regex: /[A-Z]/, label: 'Una lettera maiuscola (A-Z)' },
  { regex: /[a-z]/, label: 'Una lettera minuscola (a-z)' },
  { regex: /[0-9]/, label: 'Un numero (0-9)' },
  { regex: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/, label: 'Un carattere speciale (!@#$%...)' },
];

export const validatePassword = (password) => {
  return PASSWORD_RULES.map(rule => ({
    ...rule,
    met: rule.regex.test(password),
  }));
};

export const isPasswordValid = (password) => {
  return PASSWORD_RULES.every(rule => rule.regex.test(password));
};

export const PasswordStrengthIndicator = ({ password }) => {
  const checks = useMemo(() => validatePassword(password || ''), [password]);
  const metCount = checks.filter(c => c.met).length;

  if (!password) return null;

  return (
    <div className="mt-2 space-y-1" data-testid="password-strength-indicator">
      <div className="flex gap-1 mb-2">
        {checks.map((_, i) => (
          <div
            key={i}
            className={`h-1 flex-1 rounded-full transition-colors ${
              i < metCount
                ? metCount <= 2 ? 'bg-red-500'
                : metCount <= 4 ? 'bg-yellow-500'
                : 'bg-green-500'
                : 'bg-white/10'
            }`}
          />
        ))}
      </div>
      {checks.map((check, i) => (
        <div
          key={i}
          className={`flex items-center gap-1.5 text-xs transition-colors ${
            check.met ? 'text-green-400' : 'text-red-400'
          }`}
          data-testid={`password-rule-${i}`}
        >
          {check.met
            ? <Check className="w-3 h-3 flex-shrink-0" />
            : <X className="w-3 h-3 flex-shrink-0" />
          }
          <span>{check.label}</span>
        </div>
      ))}
    </div>
  );
};
